module.exports = __webpack_public_path__ + "static/fonts/Roboto-Medium.9c63a669.woff";